<template>
    <!-- bottom: 0px; position: absolute; -->
    <div class="m-messenger__wrapper w-100 m-messenger__wrapper--rating" style="" ><i
            class="fa fa-times btn-closed delete-response" @click="closeFormFeedback()"></i>
        <div class="m-messenger__message m-messenger__message--in w-100 mb-0">
            <div class="m-messenger__message-body w-100" style="padding: 0 20px;">
                <div class="m-messenger__message-content text-center"  :style="{'border':'1px solid ' + page.color} ">
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="mb-0 text-bold-600 mb-0"  :style="{'color':page.color}" style="margin: 5px 0;">{{config.title}}</h4>
                            <div class="rating mb-0" style="margin: 5px 0;">
                                <ul class="list">
                                    <li @click="rate(star)" v-for="(star, index) in max_stars"
                                        :class="{ 'active' : star <= current_star }" :key="star.stars" class="star"  @mouseover="current_star=(index + 1)">
                                        <!-- <i :class="star <= current_star ? 'fas fa-star' : 'far fa-star' "></i> -->
                                        <!-- FDBF00 -->
                                            <svg :class="star <= current_star ? 'light-start':''"  width="34" height="34" viewBox="0 0 34 34" fill="#cdcdcd" xmlns="http://www.w3.org/2000/svg" style="margin: 0 2.5px;" >
                                                <g clip-path="url(#clip0_79_315)">
                                                <path d="M0.823324 13.1821C2.7133 13.048 4.4574 12.9192 6.20149 12.8036C8.29466 12.6642 10.3904 12.5472 12.4823 12.3803C12.6764 12.3645 12.933 12.0937 13.0177 11.8834C14.3957 8.45256 15.7491 5.0112 17.1089 1.57247C17.1806 1.39107 17.2535 1.21099 17.3877 0.878418C17.514 1.17681 17.5961 1.3569 17.669 1.54093C19.0106 4.94022 20.36 8.33557 21.6834 11.7414C21.8619 12.2015 22.0625 12.3947 22.5965 12.4263C26.2462 12.6392 29.892 12.9074 33.5391 13.1598C33.6394 13.1664 33.7384 13.1887 33.965 13.2216C32.8318 14.1943 31.7846 15.0934 30.736 15.9925C28.8877 17.5752 27.0447 19.1644 25.1859 20.7326C24.8603 21.0073 24.7835 21.2466 24.8955 21.6791C25.8177 25.2387 26.7047 28.8076 27.6008 32.3751C27.6529 32.5815 27.692 32.7892 27.7623 33.1086C27.455 32.9206 27.2361 32.7918 27.0225 32.6551C23.9889 30.7202 20.9514 28.7931 17.9321 26.8385C17.5205 26.5716 17.2405 26.59 16.8406 26.8477C13.8369 28.7879 10.8177 30.7044 7.80361 32.6288C7.56655 32.78 7.32558 32.9246 6.99994 33.1244C7.51444 31.0817 8.0055 29.1244 8.49916 27.1684C8.95244 25.3754 9.37968 23.5746 9.87724 21.7934C10.027 21.2571 9.88897 20.9679 9.4969 20.6353C6.77851 18.3337 4.07575 16.0109 1.36909 13.6948C1.2232 13.5699 1.08774 13.4319 0.822021 13.1834L0.823324 13.1821Z" />
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_79_315">
                                                <rect width="33.1417" height="32.246" fill="#cdcdcd" transform="translate(0.823486 0.876953)"/>
                                                </clipPath>
                                                </defs>
                                                </svg>
                                            
                                                
                                    </li>
                                </ul>
                            </div>
                            <textarea :style="{'border':'1px solid ' + page.color} "
                                :placeholder="config && config.follow_up && config.follow_up.placeholder ? config.follow_up.placeholder : getPlaceholderRecomend()"
                                rows="4" class="form-control" id="recomend-content" v-model="recomend_content" ></textarea>
                            <button class="btn btn-primary w-100 mt-1 btn-rating-comment" v-if="current_star" @click="rating_submit()" :style="styleObject" style="border-radius: 20px;">{{getButtonTitle()}}</button>
                            <button class="btn btn-primary w-100 mt-1 btn-rating-comment" v-else style="cursor: not-allowed;border-radius: 20px;max-width: 80%;padding: 9px 0;    " :style="styleObject">{{getButtonTitle()}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        props: [
            'config',
        ],
        data() {
            return {
                current_star: 0,
                max_stars: 5,
                recomend_content: '',
                message_id: ''

            }
        },
        created: function () {
        },
        mounted: function () {
            
        },
        methods: {
            rate(star) {
                if (typeof star === 'number' && star <= this.max_stars && star >= 0) {
                    this.current_star = star;
                }
            },
            rating_submit: function () {
                var $self = this;
                var data_rating = {
                    page_id: livechat.getId(),
                    rating_star: $self.current_star,
                    rating_recommend: $self.recomend_content,
                    message_id: $self.message_id,
                    question_id: $self.config.id,
                    sender_id: $self.st_token,
                    name: window.user.name,
                    windowInfo: livechat.windowInfo,
                    survey_data: {
                        name: window.user.name,
                        phone: window.user.phone,
                        email: window.user.email,
                        address: window.user.address
                    },
                    properties: window.user.properties
                };
                axios.post('/app/v1/public/RATING_NEW', data_rating)
                    .then((response) => {
                        $self.closeFormFeedback({
                            message_id: $self.message_id,
                            rating_star: $self.current_star,
                            rating_recommend: $self.recomend_content,
                        });
                    }).catch(error => {
                        console.log(error);
                    });
            },
            closeFormFeedback: function (dataEmit = []) {
                this.$emit('close-feedback-form', dataEmit)
            },
            getPlaceholderRecomend: function(){
                var currentLanguage = this.config.language;
                if(currentLanguage && this.$i18n.messages){
                    var messages = this.$i18n.messages;
                    if(messages[currentLanguage] && messages[currentLanguage]['share_more_reviews']) return messages[currentLanguage]['share_more_reviews'];
                    else return this.$t('share_more_reviews');
                }
                else return this.$t('share_more_reviews');
            },
            getButtonTitle: function(){
                var currentLanguage = this.config.language;
                if(currentLanguage && this.$i18n.messages){
                    var messages = this.$i18n.messages;
                    if(messages[currentLanguage] && messages[currentLanguage]['send']) return messages[currentLanguage]['send'];
                    else return this.$t('send');
                }
                else return this.$t('send');
            }
        },
        watch: {
            config: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue && newValue.message_id) this.message_id = newValue.message_id;
                }
            },
        },
        computed: {
            styleObject: function() {
				return {
				'--borderColor':this.page.color,
				'--color': this.page.color,
				'--colorHover': '#fff'
				}
			},
            st_token() {
                return this.$store.state.st_token;
            },
            lang() {
                return this.$store.state.lang;
            },
            page() {
                return this.$store.state.page;
            }
        },
    }
</script>
<style scoped lang="css">
    textarea#recomend-content::-webkit-input-placeholder {
	font-style: italic;
	}
	textarea#recomend-content::-moz-placeholder {
	font-style: italic;  
	}
	textarea#recomend-content::-moz-placeholder {
	font-style: italic;  
	}
	textarea#recomend-content::-ms-input-placeholder {  
	font-style: italic; 
	}
	textarea#recomend-content:focus::placeholder {
	color: transparent;
	}
    /* css buttom rating  comment*/
	.btn-rating-comment{
		border:1px solid  var(--borderColor)  !important;
		color: #ffff;
		background-color:var(--color) !important;
	}
	.btn-rating-comment:hover{
		color:var(--color)  !important;
		background-color: #ffff  !important;
	}
   
    #rating-form {
        width: 90%;
        border: 1px solid #E8E8EB;
        padding: 0 18px 5px;
        margin: 0px 17px;
    }

    .m-timeline-1__item-body {
        margin-bottom: 1rem
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .rating {
        display: flex;
        flex-direction: column;
        align-items: center;
        /* padding: 50px; */
        color: #b7b7b7;
        /* background: #fff; */
        border-radius: 8px;
        /* box-shadow: 0 6px 33px rgba(19, 18, 18, 0.09); */
    }

    .rating .list {
        padding: 0;
        margin: 0;
    }

    .rating .list .star {
        display: inline-block;
        font-size: 42px;
        transition: all .2s ease-in-out;
        cursor: pointer;
    }

    .rating .list .star.active svg.light-start{
        fill: #FDBF00;
    }

    .rating .list .star:first-child {
        margin-left: 0;
    }

    .rating .list:hover .star svg.light-start{
        fill: #FDBF00;
    }

    .rating .list .star:hover~.star:not(.active) {
        color: inherit;
    }

    .info {
        margin-top: 15px;
        font-size: 40px;
        text-align: center;
        display: table;
    }

    .info .divider {
        margin: 0 5px;
        font-size: 30px;
    }

    .info .score-max {
        font-size: 30px;
        vertical-align: sub;
    }

    fieldset .rating-text {
        word-break: inherit;
        margin-bottom: 20px;
        margin: 0 0 10px;
        line-height: 1.6;
    }

    fieldset .rating-text button#previous,
    fieldset .rating-text button#next {
        background: inherit;
    }

    fieldset .rating-text label {
        display: flex;
    }

    fieldset .rating-text textarea {
        margin-bottom: 5px;
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
    }

    .btn-sm,
    .btn-group-sm>.btn {
        padding: 5px 10px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }

    .pull-right {
        float: right;
    }

    .pull-left {
        float: left;
    }

    .btn-primary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .form-control {
        display: block;
        width: 100%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }

    .text-center {
        text-align: center;
    }

    .text-bold-600 {
        font-weight: 600;
    }

    .mb-1 {
        margin-bottom: 1rem !important;
    }

    .rating {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #b7b7b7;
        border-radius: 8px;
    }

    .rating .list {
        padding: 0;
        margin: 0 ;
    }

    .rating .list .star {
        display: inline-block;
        font-size: 30px;
        transition: all .2s ease-in-out;
        cursor: pointer;
    }

    .rating .list .star.active {
        color: #ffe100;
    }

    .rating .list .star:first-child {
        margin-left: 0;
    }

    .rating .list:hover .star {
        color: #ffe100;
    }

    .rating .list .star:hover~.star:not(.active) {
        color: inherit;
    }

    .btn-closed {
        position: absolute;
        right: 5px;
        top: -7px;
        background: #efe8e8;
        border-radius: 50%;
        padding: 3px 5px;
        color: #1E68C6;
        cursor: pointer;
        visibility: visible;
        opacity: 1;
        z-index: 100;
    }

    textarea.form-control {
        line-height: 1.6rem;
        font-size: 1rem;
        height: auto;
        border-radius: 10px;
        resize: none;
        outline:1px solid rgb(22, 135, 197);
        border:0 !important;
    }
    textarea.form-control:focus-visible {border:0 !important;outline:1px solid rgb(22, 135, 197);}
    .m-messenger__wrapper--rating .m-messenger__message {
        display: table;
        table-layout: fixed;
    }

    .m-messenger__wrapper--rating .m-messenger__message .m-messenger__message-body {
        display: table-cell;
        vertical-align: top;
        padding: 0px;
        position: relative;
    }

    .m-messenger__wrapper--rating .row {
        display: flex;
        flex-wrap: wrap;
        margin-right: -14px;
        margin-left: -14px;
    }

    .m-messenger__wrapper--rating .col-md-12 {
        position: relative;
        width: 100%;
        padding-right: 14px;
        padding-left: 14px;
    }

    .m-messenger__wrapper--rating .m-messenger__message-content {
        margin-left: 20px;
        background: #e1e3f9;
        padding: 17px;
        margin-right: 20px;
        border-radius: 20px;
    }

    .w-100 {
        width: 100% !important;
    }

    .mt-1 {
        margin-top: 1rem !important;
    }
    #recomend-content{
        line-height: 1.2rem;
        font-size: 0.9rem;
    }
</style>